/* ---------------------------------------------------------------------------
 * MD Fashionwear — remember the shopper's place when they add from the carousel
 *
 * Adding an item makes the theme rebuild the drawer, which reset the carousel to
 * the first card and the drawer to the top — so a shopper browsing through the
 * recommendations got thrown back up the moment they added anything.
 *
 * This records the position on the way in, at click time in the CAPTURE phase so
 * it runs before the add handler changes anything. md-cart-hydrate.js puts it
 * back once the new markup lands.
 *
 * Kept in its own file so the carousel logic did not need another rewrite.
 * Loaded after md-cart-store.js, which owns saveScroll.
 * ------------------------------------------------------------------------- */

(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    if (!event.target.closest('.md-rec__add')) return;

    if (window.MDCartStore && window.MDCartStore.saveScroll) {
      window.MDCartStore.saveScroll();
    }
  }, true);
})();
